const missileType = ['bow', 'abow', 'xbow']
const meleeType = ['axe', 'taxe', 'swor', 'knif', 'tkni', 'spea', 'aspe', 'jave', 'ajav', 'pole', 'club', 'hamm', 'mace', 'scep', 'wand', 'staf', 'h2h']

export const itemGroups = {
  helm: ['helm', 'circ', 'pelt', 'phlm'],
  shld: ['shie', 'ashd', 'head', 'pala'],
  tors: ['tors'],
  miss: missileType,
  mele: meleeType,
  weap: [...meleeType, ...missileType, 'orb', 'thro', 'taxe', 'tkni', 'jave', 'ajav'],
  scep: ['scep'],
  wand: ['wand'],
  staf: ['staf'],
  bow: ['bow'],
  axe: ['axe'],
  club: ['club'],
  swor: ['swor'],
  hamm: ['hamm'],
  knif: ['knif'],
  spea: ['spea'],
  pole: ['pole'],
  xbow: ['xbow'],
  mace: ['mace'],
  tkni: ['tkni'],
  taxe: ['taxe'],
  jave: ['jave'],
  h2h: ['h2h', 'h2h2'],
  pala: ['pala', 'ashd'],
  pelt: ['pelt'],
  orb: ['orb'],
  head: ['head']
}

export const itemTypeNames = {
  shie: 'Shields',
  tors: 'Body Armor',
  gold: 'Gold',
  bowq: 'Arrows',
  xboq: 'Bolts',
  play: 'Player Body Parts',
  herb: 'Herbs',
  poti: 'Potions',
  ring: 'Rings',
  elix: 'Elixirs',
  amul: 'Amulets',
  char: 'Charms',
  boot: 'Boots',
  glov: 'Gloves',
  book: 'Books',
  belt: 'Belts',
  gem: 'Gems',
  torc: 'Torches',
  scro: 'Scrolls',

  scep: 'Scepters',
  wand: 'Wands',
  staf: 'Staves',
  bow: 'Bows',
  axe: 'Axes',
  club: 'Clubs',
  swor: 'Swords',
  hamm: 'Hammers',
  knif: 'Daggers',
  spea: 'Spears',
  pole: 'Polearms',
  xbow: 'Crossbows',
  mace: 'Maces',
  helm: 'Helmets',
  tpot: 'Throwing Potions',
  ques: 'Quest Items',
  body: 'Body Parts',
  key: 'Keys',
  tkni: 'Throwing Knives',
  taxe: 'Throwing Axes',
  jave: 'Javelins',

  weap: 'Weapons',
  mele: 'Melee Weapons',
  miss: 'Missile',
  thro: 'Thrown Weapons',
  comb: 'Thrown Weapons',

  armo: 'Armor',
  shld: 'Shields',
  misc: 'Miscellaneous',
  sock: 'Socket Fillers',
  seco: 'Off-hand Items',
  rod: 'Staves and Rods',
  misl: 'Ammunition',
  blun: 'Blunt Weapons',
  jewl: 'Jewels',
  amaz: 'Amazon Items',
  barb: 'Barbarian Items',
  necr: 'Necromancer Items',
  pala: 'Auric Shields', // this is only used on Exile runeword, it makes more sense to say shields here
  sorc: 'Sorceress Items',
  assn: 'Assassin Items',
  drui: 'Druid Items',
  h2h: 'Claws',
  orb: 'Orbs',
  head: 'Voodoo Heads',
  ashd: 'Auric Shields',
  phlm: 'Primal Helmets',
  pelt: 'Pelts Helmets',
  cloa: 'Cloaks',
  rune: 'Runes',
  circ: 'Circlets',
  hpot: 'Healing Potions',
  mpot: 'Mana Potions',
  rpot: 'Rejuvenation Potions',
  spot: 'Stamina Potions',
  apot: 'Antidote Potions',
  wpot: 'Thawing Potions',
  scha: 'Small Charms',
  mcha: 'Large Charms',
  lcha: 'Grand Charms',
  abow: 'Amazon Bows',
  aspe: 'Amazon Spears',
  ajav: 'Amazon Javelins',
  h2h2: 'Claws',
  mboq: 'Magic Arrows',
  mxbq: 'Magic Bolts',
  gem0: 'Chipped Gems',
  gem1: 'Flawed Gems',
  gem2: 'Standard Gems',
  gem3: 'Flawless Gems',
  gem4: 'Perfect Gems',
  gema: 'Amethysts',
  gemd: 'Diamonds',
  geme: 'Emeralds',
  gemr: 'Rubies',
  gems: 'Sapphires',
  gemt: 'Topazes',
  gemz: 'Skulls',
};

// export default {
//   itemTypeNames: itemTypeNames,
// }